(function () {
  const TARGETS = [
    "key features",
    "specifications",
    "frequently asked questions",
    "warranty",
    "package contents",
    "delivery",
    "what's included",
    "shipping"
  ];

  const norm = (s) =>
    (s || "")
      .replace(/\u00A0/g, " ")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();

  function isTargetHeading(el) {
    if (!el || !/^H[2-4]$/.test(el.tagName)) return false;
    const t = norm(el.textContent);
    return TARGETS.some((k) => t.startsWith(k));
  }

  // Finds the "real" rich text wrapper that actually contains the headings
  function resolveRoot(container) {
    if (!container) return null;

    // If headings are direct children, use container
    const direct = Array.from(container.children).some(isTargetHeading);
    if (direct) return container;

    // Otherwise, find the first matching heading anywhere inside and use its parent
    const firstHeading = container.querySelector("h2,h3,h4");
    if (firstHeading && firstHeading.parentElement) return firstHeading.parentElement;

    return container;
  }

  function buildAccordions(container) {
    if (!container) return;
    if (container.querySelector("details.cf-desc-accordion")) return;

    const root = resolveRoot(container);
    if (!root) return;
    if (root.querySelector("details.cf-desc-accordion")) return;

    const children = Array.from(root.children);
    const idx = children.map((el, i) => (isTargetHeading(el) ? i : -1)).filter(i => i >= 0);
    if (!idx.length) return;

    idx.forEach((startIdx, n) => {
      const headingEl = children[startIdx];
      if (!headingEl || !headingEl.isConnected) return;

      const nextStart = idx.find(i => i > startIdx);
      const stopEl = nextStart != null ? children[nextStart] : null;

      const contentNodes = [];
      let node = headingEl.nextElementSibling;
      while (node && node !== stopEl) {
        const next = node.nextElementSibling;
        contentNodes.push(node);
        node = next;
      }

      const details = document.createElement("details");
      details.className = "cf-desc-accordion";
      //if (n === 0) details.open = true; // uncomment if we want first open

      const summary = document.createElement("summary");
      summary.textContent = headingEl.textContent.replace(/\u00A0/g, " ").trim();

      const wrap = document.createElement("div");
      wrap.className = "cf-desc-accordion__content";
      contentNodes.forEach(n => wrap.appendChild(n));

      details.appendChild(summary);
      details.appendChild(wrap);

      headingEl.replaceWith(details);
    });
  }

  function init() {
    const containers = [
      document.querySelector(".dt-sc-tabs-content.rte#tab-description"),
      ...document.querySelectorAll(".product__accordion .accordion__content.rte")
    ].filter(Boolean);

    containers.forEach(buildAccordions);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  document.addEventListener("shopify:section:load", init);
})();
